<div class="sensors-overview-tables container-fluid" *ngIf="this.rights.get('readAll')">
  <div class="row">
    <h3 class="title" id="title-sensors">SENSORS</h3>
  </div>
  <div class="row justify-content-between">
    <div class="col-md-4">
      <div id="sensors-search-bar" class="float-left">
        <div class="input-group">
          <span class="input-group-addon">
            <button type="submit" id="sensors-search-button">
              <i class="fa fa-search" aria-hidden="true"></i>
            </button>
          </span>
          <input type="text" [(ngModel)]="searchTerm" class="form-control" placeholder="Search sensor"
                 (ngModelChange)="filterSensors();updateSensorsArray(this.step, 0)"
                 id="sensors-search-input">
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <button *ngIf="this.rights.get('create')" type="button" class="btn float-right" id="add-sensor-button" (click)="goToAddSensor()">ADD SENSOR
        <span> <i class="fa fa-plus" aria-hidden="true"></i>
        </span>
      </button>
    </div>
  </div>
  <div class="row" id="row-sensors-table">
    <app-sensor-overview-table
      [tableRowObjects]="displayedSensors"
      [tableAttributes]="tableProperties"
      (onTableRowClick)="onRowClick($event)"
      id="sensors-table">
    </app-sensor-overview-table>
  </div>
  <div class="row" id="pagination">
    <div>
      <span>
        Items per page:
      </span>
      <span class="selector">
        <select [(ngModel)]="this.step" (ngModelChange)="changeStep(this.step)" id="step-select">
          <option *ngFor="let step of steps" [ngValue]="step">
            {{step}}
          </option>
        </select>
      </span>
      <span>
        | {{this.filteredSensors.length === 0 ? 0: this.step * this.page + 1}}
         - {{this.filteredSensors.length < (this.page + 1) * this.step ? this.filteredSensors.length :(this.page + 1) * this.step}}
        of {{this.filteredSensors.length}} items
      </span>
    </div>
    <div class="pagination-right">
      <span class="numberOfPages">{{this.filteredSensors.length === 0 ? 0: this.page + 1}} of {{this.maxPage}} page(s)</span>
      <button class="pageSelector" [disabled]="this.isPreviousButtonDisabled" (click)="changePage(this.page -1)">
        <i class="fa fa-angle-left pageIcon" aria-hidden="true"></i>
      </button>
      <span class="selector">
        <select [(ngModel)]="this.page" (ngModelChange)="changePage(this.page)" id="page-select">
          <option *ngFor="let i of this.pages" [ngValue]="i">
            {{i+1}}
          </option>
        </select>
      </span>
      <button class="pageSelector" [disabled]="this.isNextButtonDisabled" (click)="changePage(this.page +1)">
        <i class="fa fa-angle-right pageIcon" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</div>


